export { Key as default } from './Key';
